<template>
  <div class="mb-16 md:pt-0 pt-8 lg:pt-20">
    <div class="container mx-auto max-w-screen-xl lg:mb-36">
      <div class="px-4 sm:px-8 md:px-10">
        <h1
          class="text-3xl sm:text-4xl lg:text-5xl font-semibold mb-6 mt-2 sm:mt-12 lg:mt-0 text-los-blue-darkest"
        >
          {{ workshopType.name }}
        </h1>

        <Breadcrumb
          class="mt-4 text-sm text-los-blue-darkest mb-8"
          :links="[
            { title: 'Workshops', slug: '/workshops' },
            { title: workshopType.name, slug: '/workshops/' + params.slug },
          ]"
        />
      </div>

      <div class="relative sm:px-8 md:px-10">
        <div
          class="lg:w-1/2 lg:pr-16 flex flex-col-reverse lg:flex-col gap-y-8 sm:gap-y-6"
        >
          <div class="">
            <div
              class="hidden sm:flex lg:hidden items-center float-right w-64 overflow-hidden aspect-square ml-8 mb-8 rounded-3xl"
            >
              <NuxtImg
                v-if="workshopType.img"
                loading="eager"
                class="object-cover object-center w-full h-full"
                :src="useStrapiImage(workshopType.img, 'small')"
                :alt="workshopType.img.alternativeText"
              />
            </div>

            <div class="max-sm:px-4 md:pr-6">
              <p class="mb-10 text-lg/8 md:text-xl/9">
                {{ workshopType.description }}
              </p>
              <div class="flex max-lg:justify-center">
                <a
                  @click.prevent="onClickTrainingen"
                  href="#alle-trainingen"
                  class="btn-main mb-12"
                  >Meld je direct aan</a
                >
              </div>
            </div>
          </div>
          <div
            v-if="workshopType.img"
            class="flex sm:hidden lg:flex flex-col justify-end sm:mb-0 sm:px-2 lg:px-0 h-64 sm:h-44 p-4 lg:h-72 overflow-hidden relative sm:rounded-3xl xl:rounded-[3rem] lg:w-[calc(100%+7rem)]"
          >
            <NuxtImg
              loading="eager"
              class="absolute inset-0 max-sm:left-4 object-cover object-center w-full h-full max-sm:rounded-l-[3rem]"
              :src="useStrapiImage(workshopType.img, 'medium')"
              :alt="workshopType.img.alternativeText"
            />
          </div>
        </div>
        <div
          class="lg:absolute top-0 md:right-10 lg:w-1/2 bg-los-pink-lightest sm:rounded-2xl px-5 py-10 sm:p-10"
        >
          <h3 class="content-heading text-los-purple-darkest">
            Praktische informatie
          </h3>
          <div
            v-html="
              useFormatContent(
                workshopType.information,
                'text-los-purple-darkest'
              )
            "
          ></div>
        </div>
      </div>
    </div>

    <div class="w-full my-basic" id="alle-trainingen">
      <div class="mx-auto max-w-screen-xl px-4 sm:px-8 md:px-10">
        <WorkshopApplyTemplate
          :typeName="workshopType.name"
          :active-workshop-id="query.id"
          :workshops="workshopType.workshops"
          :form-config="workshopType.form"
        >
          <template #title>{{ workshopType.listHeading }}</template>
          <template #formContent>
            <div
              v-html="
                useFormatContent(
                  workshopType.information,
                  'text-los-blue-darkest'
                )
              "
            />
          </template>
        </WorkshopApplyTemplate>
      </div>
    </div>

    <div class="w-full my-basic">
      <div class="mx-auto max-w-screen-xl px-4 sm:px-8 md:px-10">
        <CtaWorkshopTypes />
      </div>
    </div>
  </div>
</template>

<script setup>
const { params, query } = useRoute();
const { find } = useStrapi();

const { data: workshopTypeData } = await useAsyncData('workshop-type', () =>
  find('workshop-types', {
    filters: {
      slug: {
        $eq: params.slug,
      },
    },
    populate: [
      'img',
      'workshops',
      'workshops.extra_dates',
      'workshops.participants',
      'seo',
      'seo.metaImage',
      'form',
    ],
  })
);

const workshopType = computed(() => {
  return workshopTypeData.value?.data[0];
});

usePageSeo({
  ...workshopType.value.seo,
  metaImage: workshopType.value.seo?.metaImage ?? workshopType.img,
  isArticle: true,
});

function onClickTrainingen() {
  const targetElement = document.getElementById('alle-trainingen');
  if (targetElement) {
    window.scrollTo({
      top: targetElement.offsetTop,
      behavior: 'smooth',
    });
  }
}
</script>

<style lang="scss" scoped></style>
